import {IDiagnosisIdNode} from '../_interface/diagnosisid-node.interface';
import {cloneDeep, set} from 'lodash-es';

export const setTreeNode = (diagnosisId: string, parents: string[], tree: IDiagnosisIdNode = {}): IDiagnosisIdNode => {
	return set(cloneDeep(tree), [...(parents || []), diagnosisId], null);
};
